import Vue from 'vue'
import Vuex from 'vuex'
import client from "@/client"
import { setCookie } from "../utils/cookie-utils"
import config from "@/store/config"

Vue.use(Vuex)

export default new Vuex.Store({
	// todo
	// split into several coherent modules
	strict: process.env.NODE_ENV !== 'production',
	state: {
		loading: true,
		drawer: true,
		mini: true,
		systemInfo: null,
		contactInfo: null,
		token: null,
		profile: null,
		notification: {},
		notificationFCM: {},
		userCPIcons: {},
		privileges: {
			courses: {}
		}
	},
	mutations: {
		setLoading(state, value) {
			state.loading = value;
		},
		setDrawer(state, value) {
			state.drawer = value;
		},
		setMini(state, value) {
			state.mini = value;
		},
		setSystemInfo(state, value) {
			state.systemInfo = value;
		},
		setContactInfo(state, value) {
			state.contactInfo = value;
		},
		setToken(state, value) {
			setCookie("token", value);
			state.token = value;
		},
		setProfile(state, value) {
			state.profile = value;
		},
		notify(state, value) {
			state.notification = value;
		},
		notifyFCM(state, value) {
			state.notificationFCM = value;
		}
	},
	actions: {
		setLoading(state, value) {
			this.commit("setLoading", value);
		},
		setDrawer(state, value) {
			this.commit("setDrawer", value);
		},
		setMini(state, value) {
			this.commit("setMini", value);
		},
		setSystemInfo(state, value) {
			this.commit("setSystemInfo", value);
		},
		setContactInfo(state, value) {
			this.commit("setContactInfo", value);
		},
		setToken(state, value){
			this.commit("setToken", value);
			
			if(value){
				var config = {
					headers: {
						Authorization: value
					}
				}
			
				client
					.get("/api/myprofile/me", config)
					.then(response => {
						console.log(response);
						this.commit("setProfile", response.data.data);
					})
					.catch(err => {
						console.log(err);
					});}
			else {
				this.commit("setProfile", null);
			}
		},
		setProfile(state, value){
			this.commit("setProfile", value);
		},
		notify(state, value) {
			this.commit("notify", value);
		},
		notifyFCM(state, value) {
			this.commit("notifyFCM", value);
		}
	},
	modules: {
		config
	}
})
